/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["forgot-password{display:block}forgot-password>.auth-page>.auth-panel{width:800px}forgot-password>.auth-page>.auth-panel>.page-header{text-align:center}forgot-password>.auth-page>.auth-panel>.page-header>.big-text{font-size:2rem;margin-bottom:5px}forgot-password>.auth-page>.auth-panel>.page-header>.small-text{font-size:1.5rem;margin-bottom:30px}forgot-password>.auth-page>.auth-panel .back-and-reset-row{text-align:right;margin-top:20px}"];
export { styles as styles };
